import React, { Component } from 'react';
import classNames from 'classnames';
import AppTopbar from './AppTopbar';
import { AppMenu } from './AppMenu';
import { Route, Redirect } from 'react-router-dom';
import { ScrollPanel } from 'primereact/scrollpanel';
import ScreensHomeForm from "./layout/Form";
import { AppInlineProfile } from "./AppInlineProfile";
import ScreensLoginForm from "./screens/Login/Form";
import ScreensLoginMedicoSolicitanteForm from "./screens/LoginMedicoSolicitante/Form";
import ScreensLoginPacienteForm from "./screens/LoginPaciente/Form";
import ScreensLoginConvenioForm from "./screens/LoginConvenio/Form";
import { ServiceLogin } from "./service/Login";
import ScreensLogoutForm from "./screens/Logout/Form";
import { Toast } from 'primereact/toast';
import { ServiceMessage } from "./service/Message";

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import './layout/layout.css';
import './App.css';
import { ServiceConfig } from './service/Config';
import { GaleriaJob } from './components/GaleriaJob/Galeria';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={
            (props) => {

                if (ServiceLogin.isLoggedIn() === false) {
                    return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
                }

                return <Component {...props} />
            }
        }
    />
);

class App extends Component {

    constructor() {
        super();
        this.state = {
            layoutMode: 'overlay',
            layoutColorMode: 'dark',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false
        };

        this.onWrapperClick = this.onWrapperClick.bind(this);
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
        this.createMenu();

        window.globalVars = {
            acessoMedicoSolicitante: false
        };
    }

    onWrapperClick(event) {
        if (!this.menuClick) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            });
        }

        this.menuClick = false;
    }

    onToggleMenu(event) {
        this.menuClick = true;

        if (this.isDesktop()) {
            if (this.state.layoutMode === 'overlay') {
                this.setState({
                    overlayMenuActive: !this.state.overlayMenuActive
                });
            }
            else if (this.state.layoutMode === 'static') {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        }
        else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }

        event.preventDefault();
    }

    onSidebarClick(event) {
        this.menuClick = true;
        setTimeout(() => { this.layoutMenuScroller.moveBar(); }, 500);
    }

    onMenuItemClick(event) {
        if (!event.item.items) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            })
        }
    }

    createMenu() {
        this.menu = [
            { label: 'Exames', icon: 'pi pi-fw pi-calendar', command: () => { window.location = '#/portal' } },
            // {label: 'Contato', icon: 'pi pi-fw pi-plus', command: () => {window.location = '#/contato'}},
        ];
    }

    addClass(element, className) {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    removeClass(element, className) {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    componentDidUpdate() {
        if (this.state.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    }

    handleMessagesRef(el) {
        ServiceMessage.register(el);
    }

    render() {

        let wrapperClass = classNames('layout-wrapper', {
            'layout-overlay': this.state.layoutMode === 'overlay',
            'layout-static': this.state.layoutMode === 'static',
            'layout-static-sidebar-inactive': this.state.staticMenuInactive && this.state.layoutMode === 'static',
            'layout-overlay-sidebar-active': this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.state.mobileMenuActive
        });
        let sidebarClassName = classNames("layout-sidebar", { 'layout-sidebar-dark': this.state.layoutColorMode === 'dark' });

        let topbar = ServiceLogin.isLoggedIn() && window.location.hash !== '#/Jobs'
            ? (<AppTopbar onToggleMenu={this.onToggleMenu} />)
            : (<div></div>)

        let sideBar = ServiceLogin.isLoggedIn() && window.location.hash !== '#/Jobs'
            ? (
                <div ref={(el) => this.sidebar = el} className={sidebarClassName} onClick={this.onSidebarClick}>
                    <ScrollPanel ref={(el) => this.layoutMenuScroller = el} style={{ height: '100%' }}>
                        <div className="layout-sidebar-scroll-content" >
                            <AppInlineProfile />
                            <AppMenu model={this.menu} onMenuItemClick={this.onMenuItemClick} />
                        </div>
                    </ScrollPanel>
                </div>
            )
            : (<div></div>);

        return (

            <div className={wrapperClass} onClick={this.onWrapperClick}>

                <Toast ref={this.handleMessagesRef.bind(this)} />

                {topbar}
                {sideBar}

                <div>
                    <Route exact path="/" component={ScreensLoginPacienteForm} />
                    <Route exact path="/medico" component={ScreensLoginForm} />
                    <Route exact path="/medicosolicitante" component={ScreensLoginMedicoSolicitanteForm} />
                    <Route exact path="/Paciente" component={ScreensLoginPacienteForm} />
                    <Route exact path="/Convenio" component={ScreensLoginConvenioForm} />
                    <Route exact path="/logout" component={ScreensLogoutForm} />
                    <PrivateRoute path="/portal" component={ScreensHomeForm} />
                    <PrivateRoute exact path="/Jobs" component={GaleriaJob} />
                </div>
                <div className="layout-mask"></div>

            </div>
        );
    }

}

export default App;